import { child, get, getDatabase, ref } from "firebase/database";

export const searchAPI = {
    async getRecommendations() {
        try {
            const dbRef = ref(getDatabase());
            const snapshot = await get(child(dbRef, '/'))
            const artists = await snapshot.val()
            return artists
        } catch (e) {
            throw e
        }
    },
    async searchArtist(artist) {
        try {
            const dbRef = ref(getDatabase());
            const snapshot = await get(child(dbRef, '/'))
            const isFound = snapshot.hasChild(artist)
            return isFound
        } catch (e) {
            throw e
        }
    }
}